import React from 'react';
import SkeletonLoader from 'emerald-ui/lib/SkeletonLoader';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: SkeletonLoader, componentName: 'SkeletonLoader' }], 'SkeletonLoader'),
  description: (
    <span>
      The SkeletonLoader can be used to build a template for pages when the information has not loaded. It can be used
      by itself or as a wrapper for any element.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { SkeletonLoader },
      whiteBackground: true,
      code: `<SkeletonLoader loading />`,
    },
    {
      title: 'Content wrapping',
      scope: { SkeletonLoader },
      whiteBackground: true,
      code: `<SkeletonLoader loading>
  <h1>I am the content</h1>
</SkeletonLoader>`,
    },
  ],
};
